module.exports = __webpack_public_path__ + "img/empty.e1c98772.png";